import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Routable::ErrorNotfoundRoute @model={{@model}} />",{ moduleName: "mewe/templates/error-404.hbs" })